/*
*   File : index.js
*   Author URI : https://evoqueinnovativelab.com
*   Description : Index file for Notification container;
 *   Integrations : 23-01-2023
 *   Version : v1.0
 *   Created : 17-10-2022	
*/

/*import packages*/
import React, { useEffect, useState, useRef } from 'react';
import $ from 'jquery';
import { Modal } from 'bootstrap';
import moment from 'moment';

import Preview from '../../assets/images/banner/preview.svg';
import LoaderImg from '../../assets/images/loader/mintd-loader.gif'
import Delete from '../../assets/images/modal/delete.svg';

/*import components*/
import { FileUpload, Input, Radio, TextArea, Datepicker, TimePicker } from '../../components/input/index';
import { PrimaryBtn, SecondaryBtn, TextBtn, Toggle } from '../../components/cta/index';
import { Toast } from '../../components/note';
import { Editor } from '../../components/input/index';
import { NotificationConfirm, EmailPreview } from '../../components/modal';
import SelectBox from '../../components/dropdown/selectBox';
import { FundsTab } from '../../components/dataFormating';
import WhatsAppMessage from './whatsapp-message';
import EmailMessage from './email';
import WebinarPreview from '../../components/notification/webinarPreview';
import { DataTable } from '../../components/dataFormating';
import { Loader } from '../../components/loader';

import WhatsAppIcon from '../../assets/images/notification/whatsapp.png';
import GmailIcon from '../../assets/images/notification/gmail.png';

/* import services */
import devconfig from '../../config/config';
import APIPost from '../../services/postApi';
import APIGet from '../../services/getApi';
import Home from './home';
import styles from '../../styles/components/viewMessage.module.scss';
import style from '../../styles/components/searchInput.module.scss';

import { message } from 'antd';
import { prependEmailBanner, prepareHtmlForPreview } from '../../config/emailTemplate';

const DEVICE_OPTIONS = [
	{
		label: "Google Android", value: 1
	},
	{
		label: "iOS", value: 2
	}
];

const REDIRECTION_TYPE = [
	{ label: "URL", value: 1 },
	{ label: "Basket", value: 2 }
];


const TIME_SLOT = [
	{ value: '08:00:00AM', label: '08:00 AM' },
	{ value: '09:00:00AM', label: '09:00 AM' },
	{ value: '10:00:00AM', label: '10:00 AM' },
	{ value: '11:00:00AM', label: '11:00 AM' },
	{ value: '12:00:00PM', label: '12:00 PM' },
	{ value: '01:00:00PM', label: '01:00 PM' },
	{ value: '02:00:00PM', label: '02:00 PM' },
	{ value: '03:00:00PM', label: '03:00 PM' },
	{ value: '04:00:00PM', label: '04:00 PM' },
	{ value: '05:00:00PM', label: '05:00 PM' },
	{ value: '06:00:00PM', label: '06:00 PM' },
	{ value: '07:00:00PM', label: '07:00 PM' }
];

const FREQUENCY = [
	{ value: 'daily', label: 'Daily' },
	{ value: 'weekly', label: 'Weekly' }
]
const TABS = [
	"Home",
	"Notification",
	"Whatsapp",
	"Email",
];

const NORMALIZED_SIP_DATES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];

const STORED_DATA = {
	title: "",
	image: "",
	content: "",
	redirection_type: "URL",
	url: "",
	basket: null,
	message: "",
	target: null,
	csv: "",
	csv_name: "",
	segment: null,
	signup: null,
	rebalance: null,
	date: null,
	send_later: false,
	start_date: null,
	end_date: null,
	time: null,
	frequency: null,
	week_day: null,
	month_day: null,
	users: [],
	is_one_time: false,
}

const LOCAL_STORAGE_KEY = 'notification_data';

const Index = () => {
	const searchRef = useRef(null);
	const [title, setTitle] = useState("");
	const [content, setContent] = useState("");
	const [error, setError] = useState(null);
	const [success, setSuccess] = useState(null);
	// const [notificationData, setNotificationData] = useState([]);
	// const [tabIndex, setTabindex] = useState(1);
	// const [loader, setLoader] = useState(true);
	const [loader, setLoader] = useState(false);
	const [imageUrl, setImageUrl] = useState("");
	const [imageName, setImageName] = useState("");
	const [fileUpload, setFileUpload] = useState(false);
	const [previewUrl, setPreviewUrl] = useState("");
	const [longDescription, setLongDescription] = useState("");
	const [type, setType] = useState(1);
	const [userUrl, setUserUrl] = useState("");
	const [csvName, setCsvName] = useState("");
	//eslint-disable-next-line
	const [csvLoader, setCsvLoader] = useState(false);
	const [openPopup, setOpenPopup] = useState(false);
	const [device, setDevice] = useState(DEVICE_OPTIONS[0]);
	const [descriptionType, setDescriptionType] = useState(3);
	const [url, setUrl] = useState("");
	const [selectedRedirectionType, setSelectedRedirectionType] = useState("URL");
	const [selectedBasket, setSelectedBasket] = useState(null);
	const [basketFilter, setBasketFilter] = useState([]);
	const [generalFilters, setGeneralFilters] = useState([]);
	const [message, setMessage] = useState("");
	const [tabIndex, setTabindex] = useState(1);
	const [sendLater, setSendLater] = useState(false);
	const [selectedSegment, setSelectedSegment] = useState(null);
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [addedTime, setAddedTime] = useState(null);
	const [selectedFrequency, setSelectedFrequency] = useState(null);
	const [selectedSignUpStatus, setSelectedSignUpStatus] = useState(null);
	const [selectedRebalanceStatus, setSelectedRebalanceStatus] = useState(null);
	const [selectedRepeatDay, setSelectedRepeatDay] = useState(null);
	const [showDropdown, setShowDropdown] = useState(false);
	const [repeatedDate, setRepeatedDate] = useState(null);
	const [selectedRepeatedDate, setSelectedRepeatedDate] = useState(null);
	const [selectedWeekDay, setSelectedWeekDay] = useState(null);
	const [editableData, setEditableData] = useState(null);
	const [sendAgain, setSendAgain] = useState(false);
	const [notificationUsers, setNotificationUsers] = useState([]);
	const [popUpTitle, setPopUpTitle] = useState(null);
	const [whatsAppTitle, setWhatsAppTitle] = useState("MIRA Money");
	const [emailTitle, setEmailTitle] = useState("MIRA Money");
	const [popUpContent, setPopUpContent] = useState(null);
	const [whatsAppContent, setWhatsAppContent] = useState(null);
	const [emailContent, setEmailContent] = useState(null);
	const [popUpImage, setPopUpImage] = useState([]);
	const [whatsAppImage, setWhatsAppImage] = useState([]);
	const [emailImage, setEmailImage] = useState([]);
	const [emailBannerUrl, setEmailBannerUrl] = useState(null);
	const [notificationListLoader, setNotificationListLoader] = useState(false);
	const [previewMediaType, setPreviewMediaType] = useState(1);
	const [previewHTML, setPreviewHTML] = useState(null);
	const [htmlSourceUrl, setHtmlSourceUrl] = useState(null);
	const [openUsersList, setOpenUsersList] = useState(false);
	const [isOneTime, setIsOneTime] = useState(false);
	// True when the WhatsApp `webinar_invite` template is active, so the preview
	// renders the shared WebinarPreview (header image + caption + REGISTER button).
	const [whatsAppIsWebinar, setWhatsAppIsWebinar] = useState(false);
	const [webinarData, setWebinarData] = useState({ image: "", url: "", contents: [] });

	const [storedData, setStoredData] = useState(STORED_DATA);

	const TABLE_COLUMN = [
		{
			name: 'User name',
			selector: row => row.customer_name,
			sortable: false,
			left: true,
			minWidth: '150px',
			// sortFunction: (a, b) => customDateSort(a, b, 'order_time',),
			cell: row => row.customer_name
		},
		{
			name: 'Mobile',
			selector: row => row.customer_phone,
			sortable: false,
			left: true,
			minWidth: '200px',
			// sortFunction: (a, b) => customDateSort(a, b, 'order_time',),
			cell: row => <span>{row.customer_phone ? row.customer_phone : '-'}</span>
		},
		{
			name: 'Email',
			selector: row => row.customer_name,
			sortable: false,
			left: true,
			minWidth: '200px',
			// sortFunction: (a, b) => customDateSort(a, b, 'order_time',),
			cell: row => <span>{row.customer_email ? row.customer_email : '-'}</span>
		},
		// {
		//     name: 'Status',
		//     selector: row => row.customer_name,
		//     sortable: false,
		//     left: true,
		//     minWidth: '200px',
		//     // sortFunction: (a, b) => customDateSort(a, b, 'order_time',),
		//     cell: row => <span>Scheduled</span>
		// },
	]


	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});

		// getNotifications();
	}, []);




	useEffect(() => {
		_getBasketFilter();
		_getGeneralFilters();
	}, []);

	// Restore stored state for fresh users (ignore if editing)
	useEffect(() => {
		const saved = localStorage.getItem(LOCAL_STORAGE_KEY);

		if (saved && editableData === null && tabIndex === 2) {
			try {
				const data = JSON.parse(saved);
				// keep a copy
				setStoredData(data);

				// Restore all fields from saved data (defensive)
				setTitle(data.title || "");
				setPopUpTitle(data.title);
				setContent(data.content || "");
				setPopUpContent(data.content);
				setImageUrl(data.image || "");
				setPreviewUrl(data.image || "");
				if (data.image !== "") {
					console.log('hereee')
					setPopUpImage([data.image]);
					setPreviewMediaType(1);
					setOpenPopup(true);
				}

				setSelectedRedirectionType(data.redirection_type || "URL");
				setUrl(data.url || "");
				setSelectedBasket(data.basket || null);
				setMessage(data.message || "");
				setType(data.target || 1);
				setUserUrl(data.csv || "");
				setCsvName(data.csv_name || "");
				setSelectedSegment(data.segment || null);
				setSelectedSignUpStatus(data.signup || null);
				setSelectedRebalanceStatus(data.rebalance || null);
				setSelectedRepeatDay(data.date || null);
				setSendLater(data.send_later || false);
				setStartDate(data.start_date || null);
				setEndDate(data.end_date || null);
				setAddedTime(data.time || null);
				setSelectedFrequency(data.frequency || null);
				setSelectedWeekDay(data.week_day || null);
				if (data.month_day) {
					setRepeatedDate({
						label: _formatSip(data.month_day),
						value: data.month_day
					});
				}
				setNotificationUsers(data.users || []);
				setIsOneTime(data.is_one_time);
			} catch (e) {
				// corrupted localStorage, clear it safely
				localStorage.removeItem(LOCAL_STORAGE_KEY);
				setStoredData(STORED_DATA);
			}
		}
	}, [tabIndex, editableData]);

	function convertWhatsAppToHtml(text) {
		if (!text) return "";

		let html = text;

		html = html.replace(/\*_\s*(.+?)\s*_\*/g, "<strong><em>$1</em></strong>");
		html = html.replace(/\*(.+?)\*/g, "<strong>$1</strong>");
		html = html.replace(/_\s*(.+?)\s*_/g, "<em>$1</em>");
		html = html.replace(/~\s*(.+?)\s*~/g, "<s>$1</s>");

		return html.replace(/\n/g, "<br>");
	}


	useEffect(() => {
		const shouldFetch =
			selectedSegment &&
			(
				(selectedSegment.value === 1 && selectedSignUpStatus) ||
				(selectedSegment.value === 5 && selectedRebalanceStatus)
			);
		if (shouldFetch) {
			_getNotificationUsers();
		}
	}, [selectedSegment, selectedSignUpStatus, selectedRebalanceStatus]);

	useEffect(() => {
		if (!startDate || !isOneTime) return;

		const now = moment();
		const isToday = moment(startDate, "DD-MM-YYYY").isSame(moment(), "day");
		const cutoffTime = moment("07:00:00PM", "hh:mm:ssA");

		if (isToday && now.isSameOrAfter(cutoffTime)) {
			setError("No time available for today");
		} else {
			setError("");
		}
	}, [startDate, isOneTime]);



	const _showConfirmation = () => {

		if (url) {
			if (!/^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/g.test(url)) {
				setError("Invalid URL");
				return;
			}

		}

		const modal = new Modal(document.getElementById("pushConfirm"));
		modal.show();
	}

	const _fetchHTML = (html) => {
		if (html === null) {
			setHtmlSourceUrl(null);
			setPreviewHTML(null);
			return;
		}
		setHtmlSourceUrl(html);
	}

	useEffect(() => {
		if (!htmlSourceUrl) {
			setPreviewHTML(null);
			return;
		}

		let cancelled = false;
		fetch(htmlSourceUrl)
			.then(res => res.text())
			.then(data => {
				if (!cancelled) {
					setPreviewHTML(
						prependEmailBanner(prepareHtmlForPreview(data), emailBannerUrl)
					);
				}
			})
			.catch(() => {
				if (!cancelled) {
					setPreviewHTML(null);
				}
			});

		return () => {
			cancelled = true;
		};
	}, [htmlSourceUrl, emailBannerUrl]);


	const _resetForm = () => {
		setTitle("");
		setPopUpTitle(null);
		setContent("");
		setPopUpContent(null);
		setImageUrl("");
		setPopUpImage(null)
		setPreviewUrl("");
		setImageName("");
		setFileUpload(false);
		setLongDescription("");
		setUrl("");
		setSelectedBasket(null);
		setMessage("");

		setType(2);
		setUserUrl("");
		setCsvName("");
		setNotificationUsers([]);
		setSelectedSegment(null);
		setSelectedSignUpStatus(null);
		setSelectedRebalanceStatus(null);
		setSelectedRepeatDay(null);
		setIsOneTime(false);
		setSendLater(false);
		setStartDate(null);
		setEndDate(null);
		setAddedTime(null);
		setSelectedFrequency(null);
		setSelectedRepeatedDate(null);
		setRepeatedDate(null);
		setSelectedWeekDay(null);

		setOpenPopup(false);
	};


	const _getBasketFilter = () => {
		const url = devconfig.admin + "/banner/basket-filter";
		APIGet(url).then((response) => {
			if (response.status_code === 200) {
				const basket_filter = [];
				response.data.map((item) => {
					return (
						basket_filter.push({
							value: item.id,
							...item
						})
					)
				})
				setBasketFilter(basket_filter)
			}
		})
	}

	const _getNotificationUsers = () => {
		setNotificationListLoader(true);
		const url = devconfig.admin + '/notification/get-users';
		let payload = JSON.stringify({
			segment_type: selectedSegment?.value,
			segment_type_option: selectedSegment?.value === 1 ? selectedSignUpStatus?.value : selectedSegment?.value === 5 ? selectedRebalanceStatus?.value : null,
			segment_days: selectedSegment?.value !== 1 && selectedSegment.value !== 5 ? Number(selectedRepeatDay) : null,
		});
		APIPost(url, payload).then((response) => {
			if (response.status_code === 200) {
				setNotificationUsers(response.data);
			} else {
				setNotificationUsers([]);
			}
			setNotificationListLoader(false);
		})

	}

	const _getGeneralFilters = () => {
		const url = devconfig.admin + '/notification/filter-data';
		APIGet(url).then((response) => {
			if (response.status_code === 200) {
				const transformedData = {};

				Object.keys(response.data).forEach((key) => {
					const item = response.data[key];

					// Case 1: If value is an array
					if (Array.isArray(item)) {
						transformedData[key] = item.map((obj) => ({
							value: obj.id,
							label: obj.label
						}));
					}

					// Case 2: If value is an object (repeat_day, repeat_frequency)
					else if (typeof item === "object" && item !== null) {
						transformedData[key] = Object.keys(item).map((id) => ({
							value: Number(id),
							label: item[id]
						}));
					}

					// Case 3: Anything else pass as it is
					else {
						transformedData[key] = item;
					}
				});
				setGeneralFilters(transformedData)
			}
		})
	}

	/*----- send global notification api ---*/
	const _sendGlobalNotification = () => {
		setLoader(true);

		let api_url = sendAgain ? devconfig.admin + '/notification/v2/send-global' : editableData !== null ? devconfig.admin + '/notification/edit-scheduled-notification' : devconfig.admin + '/notification/v2/send-global'
		let schedule_data = sendLater ? {
			is_one_time: isOneTime,
			start_date: startDate,
			end_date: endDate,
			frequency: selectedFrequency?.value,
			repeat_day: selectedWeekDay?.value,
			repeat_date: repeatedDate?.value,
			time: addedTime?.value
		} : null;
		let data = JSON.stringify({
			schedule_id: editableData?.id,
			channel: 1,
			type: type,
			csv_url: userUrl,
			segment_type: selectedSegment?.value,
			segment_type_option: selectedSignUpStatus?.value || selectedRebalanceStatus?.value,
			segment_days: selectedRepeatDay,
			notification_data: {
				title: title,
				message: content,
				image: imageUrl,
				long_description: selectedRedirectionType === "URL" ? longDescription : selectedRedirectionType === "MESSAGE" ? message : null,
				redirection_type: selectedRedirectionType,
				basket_id: selectedRedirectionType === "BASKET" ? selectedBasket?.value : null,
				url: selectedRedirectionType === "URL" ? url : null,
			},
			schedule_message: schedule_data,
			whatsapp_data: null,
			email_data: null
		});


		APIPost(api_url, data).then((response) => {
			if (response.status_code === 200) {

				// Keep draft + form fields populated so the admin can send a test to themselves
				// first and then re-send the same content to clients without re-entering it.
				// try {
				// 	localStorage.removeItem(LOCAL_STORAGE_KEY);
				// } catch (e) {
				// 	// ignore
				// }
				// setStoredData(STORED_DATA);

				if (editableData) {
					setTabindex(1);
					setSuccess("Notification has been updated");
					setEditableData(null);
				} else {
					// _resetForm(); // intentionally NOT clearing fields after send (test → client flow)
					if (sendLater) {
						setSuccess(`This message will be sent to ${type === 1 ? "All users" : `the selected ${notificationUsers?.length ? notificationUsers?.length + " " : ""}users`}. An intimation mail will send to the admin once it finishes sending the message to the selected user.`);
					}
					else {
						setSuccess(`This message will be sent to ${type === 1 ? "All users" : `the selected ${notificationUsers?.length ? notificationUsers?.length + " " : ""}users`}. An intimation mail will send to the admin once it finishes sending the message to the selected user.`);
					}
				}
				setLoader(false);
			} else {
				setError(response.message);
				setLoader(false);
			}
		});
	}

	const _uploadFile = (temp, for_users) => {
		const allowedImageTypes = [
			"image/jpeg",
			"image/jpg",
			"image/png"
		];
		const allowedDocTypes = [
			"text/csv",
		];
		const _startUpload = () => {
			let url = devconfig.admin + '/file/upload'

			let data = JSON.stringify({
				file: temp.name,
				is_public: true,
			})

			APIPost(url, data).then((response) => {
				if (response.status_code === 200) {
					if (for_users) {
						setCsvLoader(true);
					} else {
						setFileUpload(true)
					}
					_uploadDocument(response.data, temp, for_users); // upload file in AWS s3
				} else {
					setError(response.message);
					if (for_users) {
						setCsvLoader(false)
					} else {
						setFileUpload(false)
					}
				}
			})
		}

		if (for_users) {
			if (!allowedDocTypes.includes(temp.type)) {
				setError("Should only allow csv file")
				return;
			};
			setCsvLoader(true)
			_startUpload();
		} else {
			if (!allowedImageTypes.includes(temp.type)) {
				setError("Should only allow png, jpg, jpeg images")
				return;
			};
			// Only allow images with exact dimensions 1408 x 768
			let preview = URL.createObjectURL(temp);
			const img = new Image();
			img.onload = () => {
				if (img.naturalWidth !== 1408 || img.naturalHeight !== 768) {
					URL.revokeObjectURL(preview);
					setError("Uploaded file dimension is wrong, please use 1408 * 768 file");
					return;
				}
				setImageName(temp.name);
				setPreviewUrl(preview)
				setFileUpload(true)
				_startUpload();
			};
			img.onerror = () => {
				URL.revokeObjectURL(preview);
				setError("Unable to read the image file");
			};
			img.src = preview;
		}
	}

	/* Uploading to s3 */
	const _uploadDocument = async (data, file, for_users) => {
		if (for_users) {
			setCsvLoader(true)
		} else {
			setFileUpload(true)
		}
		var formdata = new FormData();
		formdata.append("key", data.upload_info.fields.key);
		formdata.append("x-amz-algorithm", data.upload_info.fields['x-amz-algorithm']);
		formdata.append("x-amz-credential", data.upload_info.fields['x-amz-credential']);
		formdata.append("x-amz-date", data.upload_info.fields['x-amz-date']);
		formdata.append("policy", data.upload_info.fields['policy']);
		formdata.append("x-amz-signature", data.upload_info.fields['x-amz-signature']);
		formdata.append("file", file, file.name);

		var requestOptions = {
			method: 'POST',
			body: formdata,
			redirect: 'follow'
		};

		fetch(data.upload_info.url, requestOptions)
			.then(response => response.text())
			.then(result => {
				if (for_users) {
					setCsvLoader(false);
					setUserUrl(data.view_info);
					setCsvName(file.name);

					// safe concurrent update
					_updateStore({ csv: data.view_info, csv_name: file.name });
				} else {
					setFileUpload(false)
					setImageUrl(data.view_info);
					setPopUpImage([data.view_info]);
					setOpenPopup(true);
					setPreviewMediaType(1);
					// safe concurrent update
					_updateStore({ image: data.view_info });
				}
			})
			.catch(error => {
				// console.log('error', error); // show error toast here
			});
	}

	const _formatSip = (selected_date) => {
		switch (selected_date) {
			case 1: return "1st of every month";
			case 2: return "2nd of every month";
			case 3: return "3rd of every month";
			case 21: return "21st of every month";
			case 22: return "22nd of every month";
			case 23: return "23rd of every month";
			default: return selected_date + "th of every month";
		};
	}

	const _clearFields = () => {
		setContent("");

		setTitle("");
		setPreviewUrl("");
		setImageName("");
		setImageUrl("");
		setPopUpImage([]);
		setCsvName("");
		setUserUrl("");
		setLongDescription("");
		setType(null);
		setDescriptionType(3);
		setOpenPopup(false)
	}


	const disabledDate = (current) => {
		if (!current) return false; // safety

		// compare only by day (ignore time-of-day)
		const today = moment().startOf('day');

		// parse startDate using the same format you store it in (DD-MM-YYYY)
		const _startDate = startDate ? moment(startDate, 'DD-MM-YYYY').startOf('day') : null;

		// If startDate exists → disable all dates <= startDate (includes startDate)
		if (_startDate && _startDate.isValid()) {
			return current.isSameOrBefore(_startDate, 'day');
		}

		// If no startDate → disable past dates including today
		return current.isSameOrBefore(today, 'day');
	};



	// Open message edit
	const _openEditMode = (data, status) => {
		setEditableData(data);
		setSendAgain(status);
		if (Number(data?.message_detail?.channel + 1) === 2) {
			console.log('dataa', data);
			setTitle(data?.title);
			setPopUpTitle(data?.title);
			setImageUrl(data?.message_detail?.notification_data?.image);
			setPopUpImage([data?.message_detail?.notification_data?.image]);
			setPreviewMediaType(1);
			setPreviewUrl(data?.message_detail?.notification_data?.image);
			setContent(data?.message_detail?.notification_data?.message);
			setPopUpContent(data?.message_detail?.notification_data?.message);
			setSelectedRedirectionType(data?.message_detail?.notification_data?.redirection_type);
			if (data?.message_detail?.csv_url !== null) {
				let file_name = data?.message_detail?.csv_url.split('/');
				setUserUrl(data?.message_detail?.csv_url);
				setCsvName(file_name[file_name.length - 1]);
			}

			if (data?.message_detail?.notification_data?.redirection_type === "URL") {
				setLongDescription(data?.message_detail?.notification_data?.long_description);
				setUrl(data?.message_detail?.notification_data?.url);
			} else if (data?.message_detail?.notification_data?.redirection_type === "BASKET") {
				// setSelectedBasket()
			} else {
				setMessage(data?.message_detail?.notification_data?.long_description);
			}
			if (data?.message_detail?.notification_data?.basket_id !== null) {
				let basket = basketFilter?.find(item => item.value === data?.message_detail?.notification_data?.basket_id);
				setSelectedBasket(basket);
			}
			setType(data?.message_detail?.type)
			if (data?.message_detail?.type === 3) {
				setSelectedSegment({ value: data?.message_detail?.segment_type, label: data?.message_detail?.segment_type_variable })
			}
			if (data?.message_detail?.segment_type === 5) {
				setSelectedRebalanceStatus({ value: data?.message_detail?.segment_type_option, label: data?.message_detail?.segment_type_option_variable })
			}
			if (data?.message_detail?.segment_type === 1) {
				setSelectedSignUpStatus({ value: data?.message_detail?.segment_type_option, label: data?.message_detail?.segment_type_option_variable });
			}

			if (data?.message_detail?.segment_days) {
				setSelectedRepeatDay(data?.message_detail?.segment_days);
			}

			if (data?.scheduled_date !== undefined && data?.scheduled_date !== null && data?.scheduled_date !== "") {
				console.log('fehhehr', data?.scheduled_date)
				setSendLater(true);
				if (data?.message_detail?.start_date) {
					setStartDate(moment(data?.message_detail?.start_date).format("DD-MM-YYYY"));
				}
				if (data?.message_detail?.end_date) {
					setEndDate(moment(data?.message_detail?.end_date).format("DD-MM-YYYY"));
				}
				if (data?.message_detail?.time) {
					let rawTime = data?.message_detail?.time;
					let cleaned = rawTime?.replace(/\s/g, '');
					let time = TIME_SLOT.find(item => item.value === cleaned)

					setAddedTime(time);
				}
				if (data?.message_detail?.frequency) {
					setSelectedFrequency({ value: data?.message_detail?.frequency, label: data?.message_detail?.frequency_var });
				}
				if (data?.message_detail?.frequency === 1) {
					let day = generalFilters?.repeat_day.find(item => item.value === data?.message_detail?.repeat_day);
					console.log('day', day)
					setSelectedWeekDay(day)
				} else {
					if (data?.message_detail?.repeat_date) {
						setSelectedRepeatedDate(data?.message_detail?.repeat_date);
						setRepeatedDate({
							label: _formatSip(data?.message_detail?.repeat_date),
							value: data?.message_detail?.repeat_date
						})
					}
				}
				setIsOneTime(data?.message_detail?.is_one_time);
			}

		}
		setTabindex(Number(data?.message_detail?.channel + 1));
	}


	const _getFile = (url) => {
		if (url == "" || url == null) {
			return;
		}
		let html_file = "";
		// useEffect(() => {
		// 	if (extension == "html") {
		// 		fetch(url)
		// 			.then(res => res.text())
		// 			.then(data => html_file =data );
		// 	}
		// }, [extension]);
		// Extract file name
		const cleanUrl = url?.split("?")[0];
		const fileName = cleanUrl?.substring(cleanUrl.lastIndexOf("/") + 1);

		// Extract extension
		const extension = cleanUrl.split(".").pop().toLowerCase();

		// Type mappings

		const docExt = ["doc", "docx", "xls", "xlsx", "csv", "pdf"];
		const htmlExt = ["html"];

		// 5 → docs
		if (docExt.includes(extension)) {
			return <div className='e-csv-file-prev'><a href={url} target="_blank" rel="noreferrer">{fileName}</a></div>;
		};

		if (htmlExt.includes(extension) && html_file !== "") {
			return (
				<div className={styles.e_html}
					dangerouslySetInnerHTML={{ __html: html_file }}
				/>
			)
		}
	}

	/**
	 * _updateStore
	 * - Accepts either (keyString, value) OR (object) to set multiple keys.
	 * - Uses functional setState to avoid race conditions when called multiple times quickly.
	 * - Persists to localStorage under LOCAL_STORAGE_KEY.
	 *
	 * Usage:
	 * _updateStore('title', 'Hello');
	 * _updateStore({ title: 'Hello', content: 'World' });
	 */
	const _updateStore = (keyOrObj, maybeValue) => {
		setStoredData(prev => {
			let updated;
			// if first arg is object -> merge
			if (typeof keyOrObj === 'object' && keyOrObj !== null && !Array.isArray(keyOrObj)) {
				updated = { ...prev, ...keyOrObj };
			} else if (typeof keyOrObj === 'string') {
				updated = { ...prev, [keyOrObj]: maybeValue };
			} else {
				// invalid usage, return prev unchanged
				updated = { ...prev };
			}
			try {
				localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updated));
			} catch (e) {
				// ignore localstorage write errors
			}
			return updated;
		});
	};


	const getFileTypeFromUrl = (url) => {
		console.log('url', url);
		const cleanUrl = url.split("?")[0];
		const ext = cleanUrl.split(".").pop().toLowerCase();

		if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
		if (["mp4", "mov", "webm", "mkv"].includes(ext)) return "video";
		if (["doc", "docx", "xls", "xlsx", "pdf", "csv"].includes(ext)) return "doc";

		return "unknown";
	};

	const getFileName = (url) => {
		const cleanUrl = url.split("?")[0];
		return cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
	};

	const getEmailAttachmentItems = (attachments, inlineImageUrl) => {
		return (attachments || [])
			.filter((item) => item && item.trim() && item !== inlineImageUrl);
	};

	const renderEmailInlineImage = (url) => {
		if (!url) return null;

		return (
			<div className="e-email-inline-image">
				<img
					src={url}
					alt="Inline image"
					className="e-email-inline-image__img"
				/>
			</div>
		);
	};

	const renderEmailAttachments = (attachments, inlineImageUrl) => {
		const items = getEmailAttachmentItems(attachments, inlineImageUrl);
		if (!items.length) return null;

		const mediaItems = items.filter((item) =>
			["image", "video"].includes(getFileTypeFromUrl(item))
		);
		const docItems = items.filter((item) =>
			["doc"].includes(getFileTypeFromUrl(item))
		);

		if (!mediaItems.length && !docItems.length) return null;

		return (
			<div className="e-email-attachment-preview">
				<div className="e-email-attachment-preview__divider" />
				<div className="e-email-attachment-preview__list">
					{mediaItems.map((item, index) => {
						const type = getFileTypeFromUrl(item);

						return type === "image" ? (
							<div key={`email-attach-img-${index}`} className="e-email-attachment-preview__item">
								<img
									src={item}
									alt="Attachment"
									className="e-email-attachment-preview__thumb"
								/>
								<span className="e-email-attachment-preview__label">{getFileName(item)}</span>
							</div>
						) : (
							<div key={`email-attach-vid-${index}`} className="e-email-attachment-preview__item">
								<video
									src={item}
									className="e-email-attachment-preview__thumb"
									autoPlay
									loop
									muted
									playsInline
									controls={false}
								/>
								<span className="e-email-attachment-preview__label">{getFileName(item)}</span>
							</div>
						);
					})}
					{docItems.map((item, index) => (
						<a
							key={`email-attach-doc-${index}`}
							href={item}
							target="_blank"
							rel="noreferrer"
							className="e-email-attachment-preview__item e-email-attachment-preview__item--doc"
						>
							<div className="e-email-attachment-preview__doc-icon">📎</div>
							<span className="e-email-attachment-preview__label">{getFileName(item)}</span>
						</a>
					))}
				</div>
			</div>
		);
	};

	const renderEmailExpandedMediaPreview = () => {
		if (previewMediaType === null || tabIndex === 4) return null;

		const selectedImageArr =
			tabIndex === 2
				? popUpImage
				: tabIndex === 3
					? whatsAppImage
					: [];

		if (!selectedImageArr?.length) return null;

		if (previewMediaType === 1) {
			return (
				<div className="e-preview-media-wrapper">
					<div>
						<img
							src={selectedImageArr[0]}
							width="100px"
							className="e-cmYsgE jISezq"
							alt="preview"
						/>
						{selectedImageArr.length > 1 && (
							<p className="e-media-count-indicator">
								+{selectedImageArr.length - 1} more image
							</p>
						)}
					</div>
				</div>
			);
		}

		if (previewMediaType === 2) {
			return (
				<div className="e-preview-media-wrapper">
					<div>
						<video
							src={selectedImageArr[0]}
							width="200px"
							height="100px"
							autoPlay
							loop
							controls={false}
							style={{ objectFit: "contain" }}
						/>
						{selectedImageArr.length > 1 && (
							<p className="e-media-count-indicator">
								+{selectedImageArr.length - 1} more video
							</p>
						)}
					</div>
				</div>
			);
		}

		if (previewMediaType === 3) {
			return (
				<div className="e-preview-media-wrapper">
					<div>
						{_getFile(selectedImageArr[0])}
						{selectedImageArr.length > 1 && (
							<p className="e-media-count-indicator">
								+{selectedImageArr.length - 1} more attachment
							</p>
						)}
					</div>
				</div>
			);
		}

		return null;
	};

	const _getAvailableTime = (isOneTime) => {
		if (!isOneTime || !startDate) return TIME_SLOT;

		const now = moment();
		const selectedDate = moment(startDate, "DD-MM-YYYY");

		const isToday = selectedDate.isSame(now, "day");
		const cutoffTime = moment(selectedDate)
			.hour(19)
			.minute(0)
			.second(0);

		// ✅ If today
		if (isToday) {
			// ❌ After cutoff
			if (now.isSameOrAfter(cutoffTime)) {
				return [];
			}

			// ✅ Filter only future times
			return TIME_SLOT.filter((slot) => {
				const slotTime = moment(selectedDate)
					.hour(moment(slot.value, "hh:mm:ssA").hour())
					.minute(moment(slot.value, "hh:mm:ssA").minute());

				return slotTime.isAfter(now);
			});
		}

		// ✅ Future date → all slots available
		return TIME_SLOT;
	};




	return (
		<div className="row ">
			{
				editableData !== null ?
					<div className='col-12 my-2'>
						<span className="e-breadcrumb-link-msg"><span className='active' onClick={() => { setTabindex(2); setEditableData(null); _resetForm() }}>Message</span>/<span className='active' onClick={() => { setTabindex(1); setEditableData(null); _resetForm() }}>View message history</span>/<span className='in-active'>Edit</span></span>
					</div>
					:
					null
			}
			<div className='col-12 py-2'>
				<h6 className='e-messaging-page-title'>Messaging</h6>
			</div>
			<div className={tabIndex > 1 ? "col-lg-6 " : "col-12"}>

				{/*-----------notification card to send global notifications---------*/}
				<div className="card border-0 e-dashboard-card h-max-content pt-4 px-4 pb-2 e-notification">
					<div className="col-lg-12  mb-3">
						<FundsTab data={TABS}
							index={tabIndex}
							setTab={(temp) => {
								setTabindex(temp);
								setPopUpContent(null);
								setPopUpTitle(null);
								setPreviewMediaType(1);
								setPopUpImage([]);
								setOpenPopup(false);
								setEditableData(null);
								setSendAgain(false);
								setSendLater(false);
								setPreviewHTML(null);
								setWhatsAppImage([]);
								setEmailContent(null);
								setEmailTitle("MIRA Money ");
								setEmailImage([]);
								setWhatsAppContent(null);
								setWhatsAppIsWebinar(false);
								setWebinarData({ image: "", url: "", contents: [] });
								_resetForm();
							}} />
					</div>

					{
						tabIndex === 1 ?
							<Home openEditMode={_openEditMode} />
							:
							tabIndex === 2 ?
								<div className='row px-2'>
									<div className="col-lg-12 pe-0 mb-4">
										<label>Title</label>
										<Input
											placeholder="Notification title"
											value={title}
											className="e-notification-form-element"
											valueChange={(temp) => {
												setTitle(temp);
												setPopUpTitle(temp);
												_updateStore('title', temp);
											}}
										/>
									</div>

									<div className='col-lg-12 pe-0'>
										<label>Upload image (1408 * 768)</label>
										{
											previewUrl ?
												<div className='e-preview position-relative mb-3'>
													<img src={Delete} alt="delete"
														width={"32px"} className='position-absolute e-delete-image' style={{ right: "16px", cursor: "pointer" }}
														onClick={() => {
															setPreviewUrl("");
															setImageUrl("");
															setImageName("");
															setPopUpImage(null);
															_updateStore({ image: "", image_name: "" });
														}} />
													{
														fileUpload ?
															<img src={LoaderImg} alt="" height="40px" width="100%" style={{ objectFit: "contain", marginTop: "20px" }} />
															:
															<img src={previewUrl} alt="" height="100%" width="100%" style={{ objectFit: "contain" }} />
													}
													{/* <span className='e-choose-btn' onClick={() => { $('#e-upload').trigger("click") }}>
											<img src={Preview} alt="" height="30px" width="30px" className='me-2' />
											Change image
										</span> */}
													{/* <span className='e-drag-text'>(Drag and drop image or click here to select image)</span> */}
													<FileUpload
														accept="image/png, image/jpeg, image/jpg"
														className="d-none"
														id="e-upload"
														key="e-upload-image"
														upload={(temp) => {

															_uploadFile(temp)
														}} />
												</div>
												:
												<div className="e-uploader mb-4" onClick={() => { $('#e-upload').click() }}>
													<div className='text-center'>

														<p className='text-center mb-2'>
															{
																imageName ? imageName : "Upload an image"
															}
														</p>
														{/* 
															video !== 1 ?
															<span className='e-drag-text'>(Drag and drop image or click here to select image)</span>
															:
															null */}
													</div>
													<FileUpload
														accept="image/png, image/jpeg, image/jpg"
														className="d-none"
														id="e-upload"
														key="e-upload-image"
														upload={(temp) => {

															_uploadFile(temp)
														}} />
												</div>
										}
									</div>
									<div className="col-lg-12 pe-0 mb-4">
										<label>Content</label>
										<TextArea
											placeholder="Content of the notification"
											value={content}
											className="e-notification-form-element"
											rows="3"
											valueChange={(temp) => {
												setContent(temp);
												setPopUpContent(temp);
												_updateStore('content', temp);
											}}
										/>
									</div>
									<div className='col-lg-12 pe-0 mb-3'>
										<label className='d-flex align-items-center'>
											Redirection type
											<div onChange={(e) => {
												setSelectedRedirectionType(e.target.value);
												setSelectedBasket(null);
												setUrl("");
												_updateStore('redirection_type', e.target.value);
											}} className="d-flex ps-3">
												<Radio id="URL" value="URL" checked={selectedRedirectionType === "URL" ? true : false} label="URL" />
												<Radio id="Basket" value="BASKET" checked={selectedRedirectionType === "BASKET" ? true : false} label="Basket" />
												<Radio id="Message" value="MESSAGE" checked={selectedRedirectionType === "MESSAGE" ? true : false} label="Message" />
											</div>
										</label>
									</div>
									{
										selectedRedirectionType === "URL" ?
											<div className="col-lg-12 pe-0 mb-2">
												<label>URL</label>
												<Input
													placeholder="URL"
													value={url}
													className="e-notification-form-element"
													valueChange={(temp) => {
														setUrl(temp);
														_updateStore('url', temp);
													}}
												/>
											</div>
											: selectedRedirectionType === "BASKET" ?
												<div className='col-lg-12 pe-0 mb-2'>
													<label>Choose basket</label>
													<SelectBox
														value={selectedBasket}
														placeholder="Select basket"
														options={basketFilter}
														selectchange={(temp) => {
															setSelectedBasket(temp);
															_updateStore('basket', temp);
														}} />
												</div>
												:
												<div className="col-lg-12 pe-0 mb-2">
													<label>Message</label>
													{/* <TextArea
														placeholder="Message"
														value={message}
														className="e-notification-form-element"
														rows="3"
														valueChange={(temp) => {
															setMessage(temp);
															_updateStore('message', temp);
														}}
													/> */}
													<Editor
														editorChange={(temp) => {
															setMessage(temp);
															_updateStore('message', temp);
														}} value={message} />
												</div>
									}

									<div className="col-12 d-flex align-items-center ">
										<label className="me-3 pb-0">Target audience</label>
										<Radio id="all" value={1} label="All" checked={type === 1} valueClick={() => { setType(1); setNotificationUsers([]); _updateStore({ target: 1, users: [] }); }} />
										<Radio id="upload" value={2} label="Upload segment" checked={type === 2} valueClick={() => { setType(2); setNotificationUsers([]); _updateStore({ target: 2, users: [] }); }} />
										<Radio id="select" value={3} label="Select segment" checked={type === 3} valueClick={() => { setType(3); setNotificationUsers([]); _updateStore({ target: 3, users: [] }); }} />
									</div>
									{
										type === 3 ?

											<div className='col-12 mt-2 mb-3'>
												<SelectBox
													value={selectedSegment}
													placeholder="Choose segment"
													options={generalFilters?.segment_type}
													selectchange={(temp) => {
														setSelectedSegment(temp);
														setNotificationUsers([]);
														_updateStore({ 'date': null, 'segment': temp });
														setSelectedRepeatDay(null);
													}} />
											</div>

											: type === 2 ?
												<div className='col-lg-12'>
													<label>Upload csv url</label>
													{


														<div className="e-uploader mb-4 position-relative" onClick={() => { $('#e-csv-upload').click() }}>
															{
																csvName ?
																	<img src={Delete} alt="delete"
																		width={"32px"} className='position-absolute e-delete-image' style={{ right: "15px", top: "10px", cursor: "pointer" }}
																		onClick={(e) => {
																			e.stopPropagation();
																			setCsvName("");
																			setUserUrl("");
																			_updateStore({ csv: "", csv_name: "" });
																		}} />
																	:
																	null
															}
															<div className='text-center'>

																<p className='text-center mb-2'>
																	{
																		csvName ? csvName : "Upload csv file"
																	}
																</p>
															</div>
															<FileUpload
																accept={".csv"}
																className="d-none"
																id="e-csv-upload"
																key="e-upload-image"
																upload={(temp) => {

																	_uploadFile(temp, true)
																}} />
														</div>
													}
												</div>
												:
												null
									}

									{
										selectedSegment && type === 3 && (
											<>
												{
													selectedSegment?.value === 1 ?
														<div className='col=12 mt-2 mb-3'>
															<label>Select signup status</label>
															<SelectBox
																value={selectedSignUpStatus}
																placeholder="Choose signup status"
																options={generalFilters?.signup_staus}
																selectchange={(temp) => {
																	_updateStore('signup', temp);

																	setSelectedSignUpStatus(temp)
																}} />
														</div>
														: selectedSegment?.value === 5 ?
															<div className='col=12 mt-2 mb-3'>
																<label>Select rebalance status</label>
																<SelectBox
																	value={selectedRebalanceStatus}
																	placeholder="Choose rebalance status"
																	options={generalFilters?.rebalance_status}
																	selectchange={(temp) => {
																		_updateStore({ 'date': null, 'rebalance': temp });
																		setSelectedRepeatDay(null);
																		setSelectedRebalanceStatus(temp)
																	}} />
															</div>
															: <div className='col=12 mt-2 mb-3'>
																<label>Enter days</label>
																<div className='position-relative'>
																	<Input
																		placeholder="Enter elapsed days"
																		type="number"
																		defaultValue={selectedRepeatDay}
																		value={selectedRepeatDay}
																		className="e-notification-form-element"
																		valueChange={(temp) => {
																			_updateStore('date', temp);
																			setSelectedRepeatDay(temp);
																		}}
																	/>
																	{
																		selectedRepeatDay && (
																			<div className='e-not-search-btn' onClick={_getNotificationUsers}>
																				<img src={require('../../assets/images/notification/right-arrow.png').default} width="25px" />
																			</div>
																		)
																	}
																</div>
															</div>
												}
											</>
										)
									}


									{
										sendLater === true && (
											<div className='row pt-3 border-top'>
												<div className='col-12 d-flex justify-content-between'>
													<label className='me-5'>Schedule message</label>
													<div className='d-flex align-items-center'>
														<Toggle checked={isOneTime} onChange={(e) => {
															setIsOneTime(e.target.checked);
															_updateStore({ is_one_time: e.target.checked, frequency: null, start_date: null, end_date: null, time: null, week_day: null, month_day: null });
															setSelectedFrequency(null);
															setStartDate(null);
															setEndDate(null);
															setAddedTime(null);
															setSelectedWeekDay(null);
															setSelectedRepeatedDate(null);
															setRepeatedDate(null);
														}} />
														<span className={`${style.e_toggle_label} ps-2 `}>One time</span>
													</div>
												</div>
												{
													isOneTime === false && (
														<div className='col-6 pb-4'>
															<label className='mb-1'>Select frequency</label>
															<SelectBox
																isSearchable={false}
																options={generalFilters?.repeat_frequency}
																placeholder="Select frequency"
																value={selectedFrequency}
																selectchange={(selected_value) => {
																	setSelectedFrequency(selected_value);
																	_updateStore('frequency', selected_value);
																}} />
														</div>
													)
												}


												<div className='col-6 pb-4'>
													<label className='mb-1'>Start date</label>
													<Datepicker
														value={startDate}
														disabledDate={(current) => current.isBefore(moment().startOf("day"))}
														onChange={(value) => {
															setStartDate(value);
															_updateStore('start_date', value);
														}}
													/>

												</div>
												{
													isOneTime === false && (
														<div className='col-6 pb-4'>
															<label className='mb-1'>End date</label>
															<Datepicker
																value={endDate}
																disabledDate={disabledDate}
																onChange={(value) => {
																	setEndDate(value);
																	_updateStore('end_date', value);
																}}
															/>

														</div>
													)
												}

												<div className='col-6 pb-4'>
													<label className='mb-1'>Add time</label>
													<SelectBox
														isSearchable={false}
														options={_getAvailableTime(isOneTime)}
														placeholder="Select time"
														value={addedTime}
														selectchange={(selected_value) => {
															setAddedTime(selected_value);
															_updateStore('time', selected_value);
														}} />
												</div>

												{
													selectedFrequency ?
														<>
															{
																selectedFrequency.value === 1 ?
																	<div className='col-6 pb-4'>
																		<label className='mb-1'>Select week day</label>
																		<SelectBox
																			isSearchable={false}
																			options={generalFilters?.repeat_day}
																			placeholder="Select week day"
																			value={selectedWeekDay}
																			selectchange={(selected_value) => {
																				setSelectedWeekDay(selected_value);
																				_updateStore('week_day', selected_value);
																			}} />
																	</div>
																	: selectedFrequency.value === 2 ?
																		<div className="col-6 position-relative pb-4">
																			<label>Frequency</label>
																			<div className="cursor-pointer" onClick={() => setShowDropdown(true)}>
																				<SelectBox isDisabled
																					value={repeatedDate}
																					isSearchable={false}
																					placeholder="Select Day"
																					className=''
																				/>
																			</div>
																			{
																				showDropdown ?
																					<div className='position-absolute e-date-dropdown p-3' ref={searchRef} >
																						<div className="d-flex justify-content-between align-items-center mb-3">
																							<h6>Select date</h6>
																							<button id="close-sip"
																								type="button"
																								className="btn-close"
																								data-bs-dismiss="modal"
																								onClick={() => setShowDropdown(false)} >
																							</button>
																						</div>

																						<div className="d-flex flex-wrap text-center">
																							{NORMALIZED_SIP_DATES.map((item, key) => (
																								<div className={` d-flex align-items-center justify-content-center e-cart-date ${selectedRepeatedDate === item ? "e-active-date" : "e-cart-date color-eerie-black cursor-pointer"}`}
																									key={key}
																									onClick={() => {
																										setSelectedRepeatedDate(item)
																									}} >
																									{item}
																								</div>
																							))}

																						</div>



																						<div className='mt-3 col-12 mx-auto'>
																							<PrimaryBtn name="Confirm date"
																								className="padding-10px-tb w-100 color"
																								handleClick={() => {
																									setRepeatedDate({
																										label: _formatSip(selectedRepeatedDate),
																										value: selectedRepeatedDate
																									});
																									_updateStore('month_day', selectedRepeatedDate);
																									setShowDropdown(false)
																								}} />
																						</div>
																					</div>
																					:
																					null
																			}
																		</div>
																		:
																		null

															}
														</>
														: null
												}

											</div>
										)
									}
									<div style={{ minHeight: '60px' }}>
										{
											notificationListLoader ?
												<div className='col-12'>
													<img src={LoaderImg} alt="" height="40px" width="100%" style={{ objectFit: "contain", marginTop: "20px" }} />
												</div>
												:
												notificationUsers?.length ?
													<div className='col-12 e-view-users-table'>
														<div className='d-flex align-items-center cursor-pointer' style={{ width: 'max-content' }}
															onClick={() => setOpenUsersList(!openUsersList)}>
															<TextBtn className='mt-1 me-1'
																name={`Eligible users(${notificationUsers.length})`}
																handleClick={() => { }} />
															<div className='e-user-arrow-down'
																data-direction={openUsersList}></div>
														</div>
														<>
															{
																openUsersList === true ?
																	<DataTable
																		pagination={false}
																		columns={TABLE_COLUMN}
																		data={notificationUsers}
																		paginationServer={true}
																		selectableRows={false}
																	/>
																	: null
															}
														</>

													</div>
													: null
										}
									</div>

									<div className="col-lg-12 d-flex justify-content-start text-left mb-3 mt-4">
										{editableData !== null && sendAgain === false ? (
											<>
												{(() => {
													/* ---------- Segment validation ---------- */
													const segmentValid =
														type === 3
															? selectedSegment?.value === 1
																? selectedSignUpStatus
																: selectedSegment?.value === 5
																	? selectedRebalanceStatus
																	: selectedRepeatDay
															: true;

													/* ---------- Scheduling validation ---------- */
													const scheduleValid = !sendLater
														? true
														: isOneTime
															? Boolean(startDate && addedTime)
															: Boolean(
																startDate &&
																endDate &&
																selectedFrequency &&
																addedTime &&
																(selectedFrequency?.value === 1
																	? selectedWeekDay
																	: selectedFrequency?.value === 2
																		? selectedRepeatedDate
																		: true)
															);

													/* ---------- Final validation ---------- */
													const isValid =
														title?.length > 1 &&
														content?.length > 1 &&
														(selectedRedirectionType === "URL"
															? url
															: selectedRedirectionType === "BASKET"
																? selectedBasket
																: message) &&
														(type === 2
															? userUrl
															: type === 3
																? selectedSegment
																: true) &&
														Boolean(segmentValid) &&
														scheduleValid;

													return isValid ? (
														<PrimaryBtn
															name="Save"
															className={
																loader
																	? "e-notification-form-btn e-btn-loader e-disabled"
																	: "e-notification-form-btn"
															}
															handleClick={_showConfirmation}
														/>
													) : (
														<PrimaryBtn name="Save" className="e-disabled" />
													);
												})()}
											</>
										) : (
											<>
												{(() => {
													/* ---------- Segment validation ---------- */
													const segmentValid =
														type === 3
															? selectedSegment?.value === 1
																? selectedSignUpStatus
																: selectedSegment?.value === 5
																	? selectedRebalanceStatus
																	: selectedRepeatDay
															: true;

													/* ---------- Send now validation ---------- */
													const sendNowValid =
														title?.length > 1 &&
														content?.length > 1 &&
														(selectedRedirectionType === "URL"
															? url
															: selectedRedirectionType === "BASKET"
																? selectedBasket
																: message) &&
														(type === 2
															? userUrl
															: type === 3
																? selectedSegment
																: true) &&
														Boolean(segmentValid) &&
														sendLater === false;

													return sendNowValid ? (
														<PrimaryBtn
															name="Send now"
															className={
																loader
																	? "e-notification-form-btn e-btn-loader e-disabled"
																	: "e-notification-form-btn"
															}
															handleClick={_showConfirmation}
														/>
													) : sendLater ? (
														<SecondaryBtn
															name="Cancel scheduling"
															handleClick={() => setSendLater(false)}
														/>
													) : (
														<PrimaryBtn name="Send now" className="e-disabled" />
													);
												})()}

												{/* ---------- Send later / Schedule now ---------- */}
												{sendLater === false ? (
													<SecondaryBtn
														name="Send later"
														className="ms-3"
														handleClick={() => {
															_updateStore("send_later", true);
															setSendLater(true);
														}}
													/>
												) : (() => {
													const scheduleNowValid = isOneTime
														? Boolean(startDate && addedTime)
														: Boolean(
															startDate &&
															endDate &&
															selectedFrequency &&
															addedTime &&
															(selectedFrequency?.value === 1
																? selectedWeekDay
																: selectedFrequency?.value === 2
																	? selectedRepeatedDate
																	: true)
														);

													return scheduleNowValid ? (
														<PrimaryBtn
															name="Schedule now"
															className="ms-3"
															handleClick={_showConfirmation}
														/>
													) : (
														<PrimaryBtn
															name="Schedule now"
															className="ms-3 e-disabled"
														/>
													);
												})()}
											</>
										)}
									</div>




								</div>
								: tabIndex === 3 ?
									<WhatsAppMessage editableData={editableData}
										tabIndex={tabIndex}
										setPreviewTitle={(title) => { setWhatsAppTitle(title); setOpenPopup(true) }}
										setPreviewContent={(content) => { console.log('content', content); setWhatsAppContent(convertWhatsAppToHtml(content)); setOpenPopup(true) }}
										setPreviewImage={(image) => { setWhatsAppImage(image); setOpenPopup(true); console.log('hfoe') }}
										setWebinarPreview={(flag) => setWhatsAppIsWebinar(flag)}
										setWebinarData={(data) => setWebinarData(data)}
										updateMediaType={(value) => setPreviewMediaType(value)}
										closePopUp={() => { setOpenPopup(false); setWhatsAppImage([]); }}
										sendAgain={sendAgain}
										updateSuccess={(index) => { setTabindex(1); setEditableData(null) }} />
									:
									<EmailMessage editableData={editableData}
										tabIndex={tabIndex}
										setPreviewTitle={(title) => { setEmailTitle(title); setOpenPopup(true); console.log('jfieriehr') }}
										setPreviewContent={(content) => { setEmailContent(content); setOpenPopup(true); }}
										setPreviewBanner={(url) => { setEmailBannerUrl(url); setOpenPopup(true); }}
										setPreviewImage={(image) => { setEmailImage(image); console.log('erjere'); setOpenPopup(true) }}
										updateMediaType={(value) => setPreviewMediaType(value)}
										closePopUp={() => { setOpenPopup(false); setEmailImage([]); }}
										setPreviewHTML={(html) => { _fetchHTML(html) }}
										sendAgain={sendAgain}
										updateSuccess={(index) => { setTabindex(1); setEditableData(null) }} />
					}

				</div>
			</div>
			{
				tabIndex > 1 && (
					<div className="col-lg-6">
						<div className="card border-0 e-dashboard-card h-max-content pt-4 px-4 pb-2 ">
							{
								device.value === 1 ?
									<div className='e-exVHZH eXxezI'>
										<div className='e-gHetzH fTdPov'>
											<div className='e-jnWwQn bJDHE'>
												<div className='e-lGdcD dwCIcN position-relative'>
													{
														tabIndex === 3 ?
															<>
																<div className='e-phone-top-bar'>
																	<img src={require('../../assets/images/notification/top-bar.png').default} />
																</div>
																<div className='e-whatsapp-chat-header '>
																	<div className='d-flex py-2 align-items-center justify-content-between'>
																		<div className='d-flex align-items-center ms-3'>
																			<img src={require('../../assets/images/notification/right-arrow.png').default} className='e-arrow' />
																			<img src={require('../../assets/images/notification/favicon.webp').default} className='e-chat-profile' />
																			<div className=''>
																				<p className='e-chat-name mb-0 mt-2'>MIRA Money</p>
																				<p className='e-last-seen mb-0 mt-3'>Last seen today 11: 00 AM</p>
																			</div>
																		</div>
																		<div className='e-right'>
																			<img src={require('../../assets/images/notification/call.png').default} />
																			<img src={require('../../assets/images/notification/paper-pin.png').default} />
																		</div>
																	</div>
																</div>
															</>
															:
															null
													}


													{
														tabIndex !== 3 ?
															<div className="e-cdZahM fhnWcW" data-position={tabIndex === 2 ? 'center' : 'top'}>
																<div className={openPopup ? "e-ibEqUB eDMUfQ" : "e-ibEqUB  jlzOwm"} onClick={() => setOpenPopup(!openPopup)}>
																	{
																		tabIndex === 2 ?
																			<div className="e-lbhYTY iSaNhF">
																				<div className="e-hCDzWh jWpOyP">
																					<span className="e-eBxihg iJWpSm"></span>
																				</div>
																			</div>
																			: tabIndex === 3 ?
																				<img src={WhatsAppIcon} width="40px" height="40px" />
																				: <img src={GmailIcon} width="40px" height="40px" />
																	}

																	<header className={"e-eTFcpK dhiXIF ms-2"}>
																		<div className="e-gauFBm kHNOOQ">

																			{
																				tabIndex !== 2 ?
																					<h1 className="e-kRktcz jgpaiD">{tabIndex === 2
																						? ""
																						: tabIndex === 3
																							? whatsAppTitle
																							: emailTitle} </h1>
																					: null
																			}


																			{
																				tabIndex === 2 &&
																				<span className="e-cBQgDv gcOyUw">MIRA Money . now</span>
																			}

																		</div>
																		{
																			openPopup ?
																				null
																				:
																				<>

																					<div className="e-ejVUYw djPDJK" dangerouslySetInnerHTML={{ __html: popUpTitle || "Default message" }} />

																				</>
																		}
																	</header>
																	{
																		<div className="e-hFvvYD gYnYpU">
																			{
																				openPopup ?
																					<span className="e-ldZUWu cwKmnI "></span>
																					:
																					<span className="e-ldZUWu jsykPp "></span>
																			}
																		</div>
																	}

																	{
																		openPopup ? (
																			<>
																				{console.log('emailTitle', emailTitle, tabIndex)}
																				{/* ---------- TITLE BASED ON TAB ---------- */}
																				<h1 className="e-kRktcz jgpaiE">
																					{tabIndex === 2
																						? popUpTitle
																						: tabIndex === 3
																							? whatsAppTitle
																							: tabIndex === 4 ? "" : null}
																				</h1>

																				{tabIndex === 4 ? (
																					<div className="e-ejVUYw djPDJN e-email-preview-content">
																						{emailBannerUrl && previewHTML === null
																							? renderEmailInlineImage(emailBannerUrl)
																							: null}
																						{emailContent ? (
																							<div
																								className="e-email-preview-body"
																								dangerouslySetInnerHTML={{ __html: emailContent }}
																							/>
																						) : null}
																						{previewHTML !== null ? (
																							<div className='e-html-wrapper'>
																								<TextBtn name="Expand view"
																									toggle="modal"
																									target="#view-email"
																									className="e-instruction-btn view-full mb-3 "
																									handleClick={(e) => e.stopPropagation()} />
																								<div
																									className='mira-html-content'
																									dangerouslySetInnerHTML={{ __html: previewHTML }}
																								/>
																							</div>
																						) : null}
																						{renderEmailAttachments(emailImage, emailBannerUrl)}
																					</div>
																				) : (
																					<div
																						className="e-ejVUYw djPDJN"
																						dangerouslySetInnerHTML={{
																							__html:
																								tabIndex === 2
																									? popUpContent
																									: whatsAppContent,
																						}}
																					/>
																				)}

																				{renderEmailExpandedMediaPreview()}

																			</>
																		) : null
																	}

																</div>
															</div>
															:
															// Whats app chat-----
															<div className='e-whatsapp-chat-box'>

																<div className={whatsAppIsWebinar ? 'e-chatbox e-chatbox-webinar' : 'e-chatbox'}>
																{whatsAppIsWebinar ? (
																	<WebinarPreview image={webinarData.image} url={webinarData.url} contents={webinarData.contents} />
																) : (
																	<>
																	<div className='e-w-message-section'>
																		<div className='e-text-container'>
																			{
																				!whatsAppContent?.includes('Hi <b>[Client Name]</b>') && (
																					<p>Hi <b>[Client Name]</b></p>
																				)

																			}

																			<p
																				dangerouslySetInnerHTML={{
																					__html: whatsAppContent,
																				}}
																			/>
																		</div>

																		<>
																			{
																				previewMediaType === 1 ?
																					<>
																						{
																							whatsAppImage.length ?
																								<div className='e-slider'>
																									{
																										whatsAppImage.map((item) => {
																											return (
																												<img src={item} />
																											)
																										})
																									}
																								</div>
																								:
																								null
																						}
																					</>

																					:
																					previewMediaType === 2 ?
																						<>
																							{
																								whatsAppImage.length ?
																									<div className='e-slider'>
																										{
																											whatsAppImage.map((item) => {
																												return (
																													<video
																														src={item}
																														width="180px"
																														height="150px"
																														controls={false}
																														autoPlay
																														loop
																														style={{ objectFit: "contain" }}
																													/>
																												)
																											})
																										}
																									</div>
																									:
																									null
																							}
																						</>
																						:
																						<div>
																							{
																								whatsAppImage.length ?
																									<>
																										{
																											whatsAppImage.map((item) => {
																												return (
																													<div>{_getFile(item)}</div>
																												)
																											})
																										}
																									</>
																									:
																									null
																							}
																						</div>

																			}
																		</>
																		{/* <p className='mb-0' style={{ color: '#646363ed' }}>If you have any questions, please reach out for support.
																			Regards</p> */}
																	</div>
																	<div className='e-template-button text-center'>
																		<p>
																			<a href='tel:+916364942933'><img src={require('../../assets/images/notification/call.png').default} /> Talk to us</a>
																		</p>
																	</div>



																</>
																)}
															</div>

																{/* Input section */}
																<div className="e-whatsapp-input-wrapper">
																	<div className="e-whatsapp-input">
																		<button className="e-icon-btn">
																			<img src={require('../../assets/images/notification/smile.png').default} width="20px" />
																		</button>

																		<input
																			type="text"
																			placeholder="Type a message"
																			className="e-message-input"
																		/>

																		<button className="e-icon-btn">
																			<img src={require('../../assets/images/notification/camera.png').default} width="20px" />
																		</button>
																	</div>

																	<button className="e-mic-btn">
																		<img src={require('../../assets/images/notification/mic.png').default} />
																	</button>
																</div>
																{/* End of Input section */}

															</div>
													}


												</div>
											</div>
										</div>
									</div>
									:
									<div className="e-exVHZH eXxezI">
										<div className="e-gHetzH fTdPov">
											<div className="e-jnWwQn bJDHE">
												<div className="e-jUtGcO eLyRQE">
													<div className="e-eCDnqH ewaPOn" style={{ marginTop: tabIndex === 3 && '53px' }}>
														{/* e-keNpes fDvEly */}
														{
															tabIndex !== 3 ?
																<div className="e-keNpes fDvEly">
																	<div className='e-iJyeUs'>
																		<div className="e-feINqK jQzjPe">
																			{tabIndex === 2 ? (
																				<div className="e-hrzOVh jARDEl">
																					<div className="e-hcJkSI hthLDl">
																						<div className="e-jTUlZf bGfzT"></div>
																					</div>
																				</div>
																			) : tabIndex === 3 ? (
																				<img src={WhatsAppIcon} width="40px" height="40px" />
																			) : (
																				<img src={GmailIcon} width="40px" height="40px" />
																			)}

																			<div className="e-lcoedz kjMA-dz">
																				<h2 className="e-lmHNfd cswsXo">
																					{tabIndex === 2
																						? popUpTitle
																						: tabIndex === 3
																							? whatsAppTitle
																							: emailTitle}
																				</h2>

																				{tabIndex === 4 && emailBannerUrl && previewHTML === null
																					? renderEmailInlineImage(emailBannerUrl)
																					: null}

																				<div className={`e-fpcwso kHEcjk mt-1 ${tabIndex === 4 ? "e-email-preview-content" : ""}`}>
																					<div
																						className="e-bdxVC jUeHVs"
																						dangerouslySetInnerHTML={{
																							__html:
																								tabIndex === 2
																									? popUpContent
																									: tabIndex === 3
																										? whatsAppContent
																										: emailContent || "Default message",
																						}}
																					/>
																				</div>
																			</div>

																			<div className="e-eMWWsl gDJlbH">
																				<div className="e-fYIOIr iajhFQ">now</div>
																			</div>
																		</div>

																		{tabIndex === 4
																			? renderEmailAttachments(emailImage, emailBannerUrl)
																			: renderEmailExpandedMediaPreview()}
																	</div>
																</div>
																:
																<div className='e-whatsapp-chat-box ios-chatbox'>

																	<div className='e-chatbox'>
																		<p
																			dangerouslySetInnerHTML={{
																				__html: whatsAppContent,
																			}}
																		/>

																		<>
																			{
																				previewMediaType === 1 ?
																					<>
																						{
																							whatsAppImage.length ?
																								<div className='e-slider'>
																									{
																										whatsAppImage.map((item) => {
																											return (
																												<img src={item} />
																											)
																										})
																									}
																								</div>
																								:
																								null
																						}
																					</>

																					:
																					previewMediaType === 2 ?
																						<>
																							{
																								whatsAppImage.length ?
																									<div className='e-slider'>
																										{
																											whatsAppImage.map((item) => {
																												return (
																													<video
																														src={item}
																														width="200px"
																														height="100px"
																														controls={false}
																														autoPlay
																														loop
																														style={{ objectFit: "contain" }}
																													/>
																												)
																											})
																										}
																									</div>
																									:
																									null
																							}
																						</>
																						:
																						<div>
																							{
																								whatsAppImage.length && whatsAppImage.map((item) => {
																									return (
																										<div>{_getFile(item)}</div>
																									)
																								})
																							}
																						</div>

																			}
																		</>




																	</div>
																</div>

														}

													</div>
												</div>
											</div>
										</div>
									</div>


							}
							{/* <div className='row'>
								<div className='col-6 offset-3  pt-4'>
									<SelectBox
										isSearchable={false}
										options={DEVICE_OPTIONS}
										value={device}
										selectchange={(selected_value) => {
											setDevice(selected_value)
										}} />
								</div>
							</div> */}
						</div>
					</div>
				)
			}

			{/*-----------notification card ends---------*/}

			{/*---------------- list of push notifications ------------*/}
			{/* <div className="col-lg-12 mt-4 position-relative">
				{
					loader === true ?
						<Loader />
						:
						<div className="e-dashboard-card card border-0 p-4">
							{
								notificationData.length > 0 ?
									<>
										<h6 className="e-card-title mb-3">Push notification history</h6>
										{
											notificationData?.map((item, key) => (
												<div className="row" key={key}>
													<div className="col-lg-12">
														<div className="card border-0 e-notification-history p-3 mb-3">
															<span className="e-notification-history-time d-block">
																{item.date}
															</span>
															<h6 className="e-title mt-1 mb-3">{item.title}</h6>
															<span className="e-notification-history-content d-block">
																{item.description}
															</span>
														</div>
													</div>
												</div>
											))
										}
									</>
									:
									<EmptyNote note="No notification found" />
							}
						</div>
				}
			</div> */}


			{/*--------- error toast --------*/}
			{
				error !== null ?
					<Toast
						data={error}
						type="error"
						id="1"
						onClose={() => {
							setError(null);
						}}
					/>
					:
					null
			}


			{/*--------- success toast --------*/}
			{
				success !== null ?
					<Toast
						data={success}
						type="success"
						id="2"
						onClose={() => {
							setSuccess(null);
						}}
					/>
					:
					null
			}

			{
				previewHTML !== null &&
				<EmailPreview title={emailTitle || ""}
					html={previewHTML} />
			}
			<NotificationConfirm
				type={type}
				notificationType={2}
				sendLater={sendLater}
				Confirm={() => {
					_sendGlobalNotification();
				}} />
		</div>
	);
}

export default Index;
